import {
  Draggable as LibDraggable,
  DraggableProps,
  Droppable as LibDroppable,
  DroppableProps,
  DragDropContext as LibDragDropContext,
  DragDropContextProps,
} from "react-beautiful-dnd";

export const Droppable = LibDroppable as unknown as React.FC<DroppableProps>;

export const Draggable = LibDraggable as unknown as React.FC<DraggableProps>;

export const DragDropContext =
  LibDragDropContext as unknown as React.FC<DragDropContextProps>;
